import { Box } from "@chakra-ui/react";
import type { ReactNode } from "react";

import Footer from "./Footer";
import Header from "./Header";

type LayoutProps = {
  children: ReactNode;
};

const Layout = ({ children }: LayoutProps) => {
  return (
    <Box
      margin="0 auto"
      transition="0.5s ease-out"
      background="mustard.500"
      backgroundImage="url(BG.png), url(BGTop.png)"
      backgroundSize="initial"
      backgroundRepeat="repeat-x"
      backgroundPosition="bottom, top"
    >
      <Header />
      <Box as="main">{children}</Box>
      <Footer />
    </Box>
  );
};

export default Layout;
